import Vue from 'vue'
import outputTransformer from '@/transformers/catalog/warehouse/extraOutputsRequest'

/**
 * @author jorge nuñez lópez <>
 *
 * Fetch extra outputs request 
 * @return {List}
 */

function urlParamsTransformer(opts) {
  return {
    warehouse: opts.warehouse,
    status: opts.status
  }
}
export default (opts) => {
  let config
  if(opts) {
    config = {
      params: urlParamsTransformer(opts)
    }
  }
  return Vue.$http.get(`iwarehouse/output_extra/list/`, config)
    .then(({ data }) => {
      const dataTransformed = outputTransformer.fetchCollection(data)
      return dataTransformed
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchExtraOutputRequest.js